// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3VH6V","col":"styles_col__sF816"};